import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode, SiPostman, SiVercel, SiDocker,
  SiJest, SiGithubactions, SiMicrosoftazure, SiKubernetes,
  SiJenkins, SiNginx,
} from "react-icons/si";
import { AiFillGithub } from "react-icons/ai";

const TOOLS = [
  { icon: <SiVisualstudiocode />, label: "VS Code"        },
  { icon: <SiPostman />,          label: "Postman"        },
  { icon: <AiFillGithub />,       label: "GitHub"         },
  { icon: <SiGithubactions />,    label: "GitHub Actions" },
  { icon: <SiMicrosoftazure />,   label: "Azure DevOps"   },
  { icon: <SiDocker />,           label: "Docker"         },
  { icon: <SiKubernetes />,       label: "Kubernetes"     },
  { icon: <SiJenkins />,          label: "Jenkins"        },
  { icon: <SiJest />,             label: "Jest"           },
  { icon: <SiNginx />,            label: "NGINX"          },
  { icon: <SiVercel />,           label: "Vercel"         },
];

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {TOOLS.map(({ icon, label }) => (
        <Col xs={4} md={2} key={label} className="tech-icons" title={label}>
          {icon}
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
